import * as fromDatatype from "../datatype-library";

export interface bl_applet_notification_subscription_hdr_RowInterface{
    guid: fromDatatype.GuidDataFieldInterface;
    event_code: fromDatatype.VarcharDatatypeInterface;
    topic_code: fromDatatype.VarcharDatatypeInterface;
    topic_description: fromDatatype.VarcharDatatypeInterface;
    topic_name: fromDatatype.VarcharDatatypeInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    tenant_guid: fromDatatype.GuidDataFieldInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    notification_type: fromDatatype.VarcharDatatypeInterface;
}

export class bl_applet_notification_subscription_hdr_RowClass implements bl_applet_notification_subscription_hdr_RowInterface{
    guid: fromDatatype.GuidDataFieldInterface;
    event_code: fromDatatype.VarcharDatatypeInterface;
    topic_code: fromDatatype.VarcharDatatypeInterface;
    topic_description: fromDatatype.VarcharDatatypeInterface;
    topic_name: fromDatatype.VarcharDatatypeInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    tenant_guid: fromDatatype.GuidDataFieldInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    notification_type: fromDatatype.VarcharDatatypeInterface;
}
